export const actionTypes = {
    SET_ACTION_BAR_DATA: 'SET_ACTION_BAR_DATA',
    SET_ACTION_BAR_CANCEL_TOKEN: 'SET_ACTION_BAR_CANCEL_TOKEN',
    IS_ACTION_BAR_FETCHING: 'IS_ACTION_BAR_FETCHING'
}